import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { MazeManager } from "./MazeManager";

export class Goal extends Phaser.GameObjects.Container {

    public currentState: string;

    private f: number;
    private yellowGoal: Phaser.GameObjects.Image;
    private whiteGoal: Phaser.GameObjects.Image;
    private cyanGoal: Phaser.GameObjects.Image;
    private flare: Phaser.GameObjects.Image;
    private pulseTween: Phaser.Tweens.Tween;
  
    constructor(scene: Phaser.Scene) {

        super(scene);

        this.f = 0;
        this.currentState = GameConstants.GOAL_POINTS;

        this.scaleY = GameVars.scaleY;

        this.flare = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "flare_score");
        this.flare.visible = false;
        this.add(this.flare); 

        this.yellowGoal = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "icon_score_ingame");
        this.add(this.yellowGoal);

        this.whiteGoal = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "icon_exit_ingame");
        this.add(this.whiteGoal);

        this.cyanGoal = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "icon_time_ingame");
        this.add(this.cyanGoal);

        this.setCurrentState();

        this.pulseTween = this.scene.tweens.add({
            targets: this,
            scaleX: 1.125,
            scaleY: 1.125 * GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.InOut,
            repeat: -1,
            yoyo: true,
            duration: 1000,
        });

        // HAY Q HACER ESTO PQ EL METODO UPDATE NO SE UTILIZA DE MANERA AUTOMATICA
        this.scene.sys.updateList.add(this);
    }

    public preUpdate(): void {

        if (GameVars.levelCompleted || GameVars.pause) {
            return;
        }

        this.f++;

        if (this.f === 90) {
            this.f = 0;
            this.setCurrentState();
        }
    }

    public mazeSolved(): void {

        this.pulseTween.stop();

        this.scene.tweens.add({
            targets: this,
            scaleX: 1.65,
            scaleY: 1.65 * GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250
        });

        // ponemos a 3 cuadrados que se desvanecen para marcarlo aun mas
        if (this.currentState !== GameConstants.GOAL_NONE) {

            for (let i = 0; i < 4; i++) {

                const square = new Phaser.GameObjects.Graphics(this.scene);
                this.add(square);

                const l = GameVars.l * .45;
                let color: number;

                switch (this.currentState) {
                    case GameConstants.GOAL_NONE:
                        color = GameConstants.COLOR_NONE;
                        break;
                    case GameConstants.GOAL_TIME:
                        color = GameConstants.COLOR_TIME;
                        break;
                    case GameConstants.GOAL_POINTS:
                        color = GameConstants.COLOR_POINTS;
                        break;
                    default:
                }

                // uno con menos alfa para crear un efecto de glow
                square.lineStyle(2.25, color, .1);
                square.strokeRect(this.x - l * .5, this.y - l * .5, l, l);

                square.lineStyle(2, color, .15);
                square.strokeRect(this.x - l * .5, this.y - l * .5, l, l);

                square.lineStyle(1.5, color, .5);
                square.strokeRect(this.x - l * .5, this.y - l * .5, l, l);

                square.lineStyle(1, color);
                square.strokeRect(this.x - l * .5, this.y - l * .5, l, l);

                this.scene.tweens.add({
                    targets: square,
                    scaleX: 5,
                    scaleY: 5,
                    angle: 10,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    delay: 100 * i,
                    duration: 500,
                    onComplete: function (): void {
                        this.scene.tweens.add({
                            targets: square,
                            scaleX: 100,
                            scaleY: 100,
                            angle: 25,
                            ease: Phaser.Math.Easing.Cubic.In,
                            delay: 50,
                            duration: 300,
                        });
                    },
                    onCompleteScope: this
                });
            }
        }
    }

    private setCurrentState(): void {

        let showFlare = false;

        if (this.currentState === GameConstants.GOAL_POINTS) {

            this.currentState = GameConstants.GOAL_TIME;

            this.yellowGoal.visible = false;
            this.whiteGoal.visible = false;
            this.cyanGoal.visible = true;

            this.flare.setFrame("flare_time");
            showFlare = true;

        } else if (this.currentState === GameConstants.GOAL_TIME) {

            this.currentState = GameConstants.GOAL_NONE;

            this.yellowGoal.visible = false;
            this.whiteGoal.visible = true;
            this.cyanGoal.visible = false;

        } else {

            this.currentState = GameConstants.GOAL_POINTS;

            this.yellowGoal.visible = true;
            this.whiteGoal.visible = false;
            this.cyanGoal.visible = false;

            this.flare.setFrame("flare_score");
            showFlare = true;
        }

        if (showFlare) {

            this.flare.visible = true;
            this.flare.alpha = 1;
            this.flare.setScale(0);

            this.scene.tweens.add({
                targets: this.flare,
                scaleX: 2,
                scaleY: 2,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 90
            });

            this.scene.tweens.add({
                targets: this.flare,
                alpha: 0,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 90,
                delay: 50,
                onComplete: function(): void {
                    this.flare.visible = false;
                },
                onCompleteScope: this
            });
        }
    }
}
